"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackableSet = void 0;
const eventemitter2_1 = require("eventemitter2");
class TrackableSet extends eventemitter2_1.EventEmitter2 {
    constructor(values, options = { wildcard: true, maxListeners: 20 }) {
        super(options);
        this._array = null;
        this._set = new Set(values);
        this._array = Array.from(this._set);
    }
    all() {
        return this._array === null ? (this._array = Array.from(this._set)) : this._array;
    }
    has(value) {
        return this._set.has(value);
    }
    add(value) {
        const newValue = !this.has(value);
        this._set.add(value);
        if (newValue) {
            this._onAdd(value);
        }
        return this;
    }
    delete(value) {
        const deleted = this._set.delete(value);
        if (deleted) {
            this._onDelete(value);
        }
        return deleted;
    }
    clear() {
        this._set.clear();
        this._onClear();
    }
    _onAdd(value) {
        this._onChange();
        this.emit('add', { value });
    }
    _onDelete(value) {
        this._onChange();
        this.emit('delete', { value });
    }
    _onClear() {
        this._onChange();
        this.emit('clear');
    }
    _onChange() {
        this._array = null;
        this.emitAsync('change', { values: this.all() });
    }
}
exports.TrackableSet = TrackableSet;
//# sourceMappingURL=trackable-set.js.map